import React from 'react'

/** Studio origin — diamond. */
export function diamondPoints(cx: number, cy: number, r: number): string {
  return `${cx},${cy - r} ${cx + r},${cy} ${cx},${cy + r} ${cx - r},${cy}`
}

/** Client cluster — flat-top hexagon. */
export function hexPoints(cx: number, cy: number, r: number): string {
  const pts: string[] = []
  for (let i = 0; i < 6; i++) {
    const a = (Math.PI / 180) * (60 * i - 30)
    pts.push(`${cx + r * Math.cos(a)},${cy + r * Math.sin(a)}`)
  }
  return pts.join(' ')
}

export type ClientGrain = 'continent' | 'country' | 'city'

/** Client clusters always use a hex (grain only affects labels/placement). */
export function ClientGlyph({
  cx, cy, r, fill, fillOpacity = 1, stroke, strokeWidth = 1.2,
}: {
  cx: number
  cy: number
  r: number
  /** @deprecated Ignored — clients are always hex. */
  grain?: ClientGrain
  fill: string
  fillOpacity?: number
  stroke: string
  strokeWidth?: number
}) {
  return (
    <polygon
      points={hexPoints(cx, cy, r)}
      fill={fill}
      fillOpacity={fillOpacity}
      stroke={stroke}
      strokeWidth={strokeWidth}
    />
  )
}

export function StudioGlyph({
  cx, cy, r, fill, fillOpacity = 1, stroke, strokeWidth = 1.4,
}: {
  cx: number
  cy: number
  r: number
  fill: string
  fillOpacity?: number
  stroke: string
  strokeWidth?: number
}) {
  return (
    <polygon
      points={diamondPoints(cx, cy, r)}
      fill={fill}
      fillOpacity={fillOpacity}
      stroke={stroke}
      strokeWidth={strokeWidth}
    />
  )
}

/** CDN / delivery path endpoint — tiny circle. */
export function EdgeGlyph({
  cx, cy, r, fill, fillOpacity = 1, stroke, strokeWidth = 1,
}: {
  cx: number
  cy: number
  r: number
  fill: string
  fillOpacity?: number
  stroke: string
  strokeWidth?: number
}) {
  return (
    <circle
      cx={cx}
      cy={cy}
      r={Math.max(3, r * 0.45)}
      fill={fill}
      fillOpacity={fillOpacity}
      stroke={stroke}
      strokeWidth={strokeWidth}
    />
  )
}
